export const OA_TYPES_BG_COLORS = {
  "Bronze": "#CD853F",
  "Closed Access": '#708090',
  "Diamond": '#DCDCDC',
  "Gold": '#F3C623',
  "Green Open Access": '#228B22',
  "Hybrid": '#6495ED',
  "Open Access": "#e78934"
}

export const OA_TYPES = [
  "Bronze",
  "Closed Access",
  "Diamond",
  "Gold",
  "Green Open Access",
  "Hybrid",
]
